"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var map = document.querySelector('.js-map');
  var markers = map.querySelectorAll('.js-marker');

  if (window.innerWidth > 1020) {
    map.addEventListener('click', function (e) {
      e.preventDefault;
      markers.forEach(function (marker) {
        marker.classList.add('close');
        marker.classList.remove('open');
      });

      if (e.target.classList.contains('js-marker')) {
        e.target.closest('.js-marker').classList.add('open');
        e.target.closest('.js-marker').classList.remove('close');
      }
    });
  }
});